import _ from 'lodash';
import { combineReducers } from 'redux';

import { getSpecInfoById, getCharacterSpecInfo } from 'shared/character';
import { getPreferredEnhancements, findEnhancement } from 'shared/items';
import SimcInput from 'shared/simcinput';

import types from 'frontend/state/actionTypes';

const selectedEnhancementsReducer = (state = [], action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case types.CLEAR_OPTIMIZE_ENHANCEMENTS: {
      const { specId, slot } = payload;
      return _.reject(state, selected => {
        if (selected.slot === 'socket') {
          // TODO: Big hack to only allow Default/None buttons for prismatic gems
          const enhancement = findEnhancement(selected.enhancementId);
          return selected.specId === specId && selected.slot === slot && enhancement.type === 'PRISMATIC';
        }
        return selected.specId === specId && selected.slot === slot;
      });
    }
    case types.SET_OPTIMIZE_ENHANCEMENTS_DEFAULT: {
      const { specId, slot } = payload;
      const specInfo = getSpecInfoById(specId);
      const preferred = getPreferredEnhancements(slot, specInfo);
      let cleared = _.reject(state, { specId, slot });
      let filtered = preferred;
      if (slot === 'socket') {
        // TODO: This is a big hack, basically only allow Default/None buttons on prismatic gems
        filtered = _.filter(preferred, { type: 'PRISMATIC' });
        cleared = _.reject(state, selected => {
          // TODO: Big hack to only allow Default/None buttons for prismatic gems
          const enhancement = findEnhancement(selected.enhancementId);
          return selected.specId === specId && selected.slot === slot && enhancement.type === 'PRISMATIC';
        });
      }
      return _.union(
        cleared,
        _.map(filtered, enhancement => ({
          specId,
          slot,
          enhancementId: enhancement.id,
        })),
      );
    }
    case types.TOGGLE_OPTIMIZE_ENHANCEMENT: {
      const { specId, slot, enhancementId } = payload;
      const search = { specId, slot, enhancementId };
      const idx = _.findIndex(state, search);
      if (idx > -1) {
        return _.reject(state, search);
      }
      return [
        ...state,
        search,
      ];
    }
    case types.LOAD_OPTIMIZE_REPORT: {
      const character = SimcInput.toCharacter(_.get(payload, 'optimize.data'));
      if (character) {
        const specInfo = getCharacterSpecInfo(character);
        if (specInfo) {
          const specId = specInfo.id;
          const result = [
            ..._.reject(state, { specId }),
            ..._.filter(payload.optimize.selectedEnhancements, { specId }),
          ];
          return result;
        }
      }
      return state;
    }
    case types.RESET_OPTIMIZE: {
      const { specId } = payload;
      return _.reject(state, { specId });
    }
    default:
      return state;
  }
};

const forceMainStatReducer = (state = [], action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case types.TOGGLE_OPTIMIZE_ENHANCEMENTS_MAIN_STAT_GEM: {
      const { specId } = payload;
      const search = { specId };
      const prev = _.find(state, search);
      if (prev) {
        return _.map(state, item => {
          if (item.specId === specId) {
            return {
              ...item,
              value: !prev.value,
            };
          }
          return item;
        });
      }
      return [
        ...state,
        {
          specId,
          value: true,
        },
      ];
    }
    case types.LOAD_OPTIMIZE_REPORT: {
      const character = SimcInput.toCharacter(_.get(payload, 'optimize.data'));
      if (character) {
        const specInfo = getCharacterSpecInfo(character);
        if (specInfo) {
          const specId = specInfo.id;
          const result = [
            ..._.reject(state, { specId }),
            ..._.filter(payload.optimize.forceMainStat, { specId }),
          ];
          return result;
        }
      }
      return state;
    }
    case types.RESET_OPTIMIZE: {
      const { specId } = payload;
      return _.reject(state, { specId });
    }
    default:
      return state;
  }
};

const algariColorsReducer = (state = false, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case types.TOGGLE_OPTIMIZE_ENHANCEMENTS_ALGARI_COLORS: {
      return !state;
    }
    case types.LOAD_OPTIMIZE_REPORT: {
      return payload.optimize.algariColors || false;
    }
    case types.RESET_OPTIMIZE: {
      return false;
    }
    default:
      return state;
  }
};

const wrathionSocketReducer = () => [];

const addSocketNumReducer = (state = 0, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case types.CHOOSE_OPTIMIZE_ADD_SOCKET_NUM: {
      return parseInt(payload, 10) || 0;
    }
    case types.LOAD_OPTIMIZE_REPORT: {
      return parseInt(payload.optimize.addSocketNum, 10) || 0;
    }
    case types.RESET_OPTIMIZE: {
      return 0;
    }
    default:
      return state;
  }
};
const addSocketGemReducer = (state = [], action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case types.CHOOSE_OPTIMIZE_ADD_SOCKET_GEM: {
      const { specId, gemId } = payload;
      return [
        ..._.reject(state, { specId }),
        { specId, gemId },
      ];
    }
    case types.LOAD_OPTIMIZE_REPORT: {
      const character = SimcInput.toCharacter(_.get(payload, 'optimize.data'));
      if (character) {
        const specInfo = getCharacterSpecInfo(character);
        if (specInfo) {
          const specId = specInfo.id;
          const result = [
            ..._.reject(state, { specId }),
            ..._.filter(payload.optimize.addSocketGem, { specId }),
          ];
          return result;
        }
      }
      return state;
    }
    case types.RESET_OPTIMIZE: {
      const { specId } = payload;
      return _.reject(state, { specId });
    }
    default:
      return state;
  }
};

const contaminantCountReducer = () => 0;


export default combineReducers({
  selectedEnhancements: selectedEnhancementsReducer,
  forceMainStat: forceMainStatReducer,
  wrathionSocket: wrathionSocketReducer,
  addSocketNum: addSocketNumReducer,
  addSocketGem: addSocketGemReducer,
  contaminantCount: contaminantCountReducer,
  algariColors: algariColorsReducer,
});

const base = state => state.simbot.optimize.enhancements;
const selectedEnhancementsSelector = state => base(state).selectedEnhancements;
const forceMainStatSelector = state => base(state).forceMainStat;
const wrathionSocketSelector = state => base(state).wrathionSocket;
const addSocketNumSelector = state => base(state).addSocketNum;
const addSocketGemSelector = state => base(state).addSocketGem;

export const selectors = {
  selectedEnhancements: selectedEnhancementsSelector,
  forceMainStat: forceMainStatSelector,
  wrathionSocket: wrathionSocketSelector,
  addSocketNum: addSocketNumSelector,
  addSocketGem: addSocketGemSelector,
  algariColors: state => base(state).algariColors,
};
